import CommitTree from './VersionControl/CommitTree'
import Main from './Main'
import Acl from './Acl'
import Settings from './Settings'
import Explore from './Explore'
import MergeRequests from './VersionControl/MergeRequests'
import Compare from './VersionControl/Compare'
import Branches from './VersionControl/Branches'
import Pipelines from './Pipelines'
import Entry from './Entry'

export {
  Branches
  CommitTree
  Compare
  Main
  Acl
  Settings
  Explore
  Entry
  MergeRequests
  Pipelines
}
